"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.StepsBanner = void 0;
require("core-js/modules/es.symbol.description.js");
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _hooks = require("../../../hooks");
var _Icon = require("../Icons/PetSure/Icon");
var _uiElementPropTypes = require("../../../propTypes/uiElementPropTypes");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const StepsBanner = _ref => {
  let {
    steps,
    bannerStyle = 'arrows',
    customCssClass,
    customTrackingData,
    customTrackingEvents,
    onCompletedStepClick,
    navigate = () => {}
  } = _ref;
  if (!steps || !steps.length) {
    return null;
  }
  const totalNumberSteps = steps.length;
  const activeStepIndex = steps.findIndex(step => step.isActive) + 1;
  const CompletedStepLink = _ref2 => {
    let {
      url,
      isActive,
      stepIndex,
      isCompleted,
      label
    } = _ref2;
    const completedStepLink = (0, _react.useRef)(null);
    (0, _hooks.useTracking)({
      elementRef: completedStepLink,
      trackingProps: {
        label,
        reactComponent: 'StepsBanner'
      },
      customTrackingData,
      customTrackingEvents
    });
    const HandleCompletedStepClick = () => {
      if (onCompletedStepClick) {
        return onCompletedStepClick({
          url,
          isActive,
          stepIndex,
          isCompleted,
          label
        });
      }
      return navigate(url);
    };
    return /*#__PURE__*/_react.default.createElement("button", {
      className: "stepBannerLink",
      type: "button",
      onClick: HandleCompletedStepClick
    }, /*#__PURE__*/_react.default.createElement(StepIconLabel, {
      isActive: isActive,
      stepIndex: stepIndex,
      isCompleted: isCompleted,
      label: label
    }));
  };
  CompletedStepLink.propTypes = _objectSpread({
    url: _propTypes.default.string
  }, _uiElementPropTypes.StepIconLabelPropType);
  const StepIconLabel = _ref3 => {
    let {
      isActive,
      isCompleted,
      stepIndex,
      label
    } = _ref3;
    const srLabel = "".concat(isActive ? 'You are currently on step' : 'Step', " ").concat(stepIndex, " of ").concat(totalNumberSteps);
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
      className: "sr-only"
    }, srLabel), /*#__PURE__*/_react.default.createElement("span", {
      className: "stepIndex",
      "aria-hidden": "true"
    }, /*#__PURE__*/_react.default.createElement("em", {
      className: isCompleted ? 'sr-only' : ''
    }, stepIndex), isCompleted && /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
      icon: "tick"
    })), /*#__PURE__*/_react.default.createElement("span", {
      className: "labelText"
    }, label));
  };
  StepIconLabel.propTypes = _uiElementPropTypes.StepIconLabelPropType;
  return /*#__PURE__*/_react.default.createElement("ul", {
    className: "stepsBanner stepsBanner_".concat(bannerStyle, " ").concat(customCssClass || '')
  }, steps.map((step, index) => {
    const {
      isActive,
      label,
      url
    } = step;
    const stepIndex = index + 1;
    const stepZIndex = totalNumberSteps - index;
    const isCompleted = step.isCompleted || stepIndex < activeStepIndex;
    return /*#__PURE__*/_react.default.createElement("li", {
      style: {
        zIndex: stepZIndex
      },
      key: "step_".concat(stepIndex),
      className: "".concat(isActive ? 'active' : '', " ").concat(isCompleted ? 'complete' : ''),
      "aria-current": step.isActive
    }, (url || onCompletedStepClick) && index < activeStepIndex - 1 ? /*#__PURE__*/_react.default.createElement(CompletedStepLink, {
      url,
      isActive,
      isCompleted,
      label,
      stepIndex
    }) : /*#__PURE__*/_react.default.createElement(StepIconLabel, {
      isActive,
      isCompleted,
      label,
      stepIndex
    }));
  }));
};
exports.StepsBanner = StepsBanner;
StepsBanner.propTypes = _uiElementPropTypes.StepsBannerPropType;
var _default = exports.default = StepsBanner;